import { $post } from '@/api/request'
// 楼宇信息下拉框列表
export function listBuildingInfos (data) {
  return $post({
    url: '/dataInfo/listBuildingInfos',
    data
  })
}
// 公司下拉框
export function listCompanyfInfo (data) {
  return $post({
    url: '/dataInfo/listCompanyInfos',
    data
  })
}
// 合同状态下拉框
export function listContractStatusInfo (data) {
  return $post({
    url: '/dataInfo/listContractStatus',
    data
  })
}
// 公司下拉框 级联楼宇和模板
export function listCompanyBuildingTemplateBriefInfo (data) {
  return $post({
    url: '/dataInfo/listCompanyBuildingTemplateBriefInfo',
    data
  })
}
// 公司-楼宇 级联下拉框
export function listCompanyBuildingInfos (data) {
  return $post({
    url: '/dataInfo/listCompanyBuildingInfos',
    data
  })
}
// 公司-招商员 级联下拉框
export function listCompanySalesPersons (data) {
  return $post({
    url: '/dataInfo/listCompanySalesPersons',
    data
  })
}
// 角色下拉框
export function listRoleInfo (data) {
  return $post({
    url: '/dataInfo/listRoleInfos',
    data
  })
}
